import { TranslationService } from '@services/translation.service';
import { ToolMapActionType } from '../models/tool-action-type';
import { ToolMapType } from '../models/tool-map-type';
import { WidgetModalType } from '../models/widget-modal-type';
import { WidgetType } from '../models/widget-type';

export function getWidgetModalLabelDictionary(ts: TranslationService): Map<WidgetModalType, string> {
  return new Map<WidgetModalType, string>([
    [WidgetModalType.LoadData, ts.getCurrentLanguage()['load-data']],
    [WidgetModalType.AddLayer, ts.getCurrentLanguage()['add-layer']],
    [WidgetModalType.HeatMap, ts.getCurrentLanguage()['heat-map']],
    [WidgetModalType.ClusterMap, ts.getCurrentLanguage()['cluster-map']],
    [WidgetModalType.CoverageQuota, ts.getCurrentLanguage()['coverage-quota']],
    [WidgetModalType.PropertyQuota, ts.getCurrentLanguage()['property-quota']],
    [WidgetModalType.SearchByDrawing, ts.getCurrentLanguage()['search-by-drawing']],
    [WidgetModalType.AdvancedSearch, ts.getCurrentLanguage()['advanced-search']],
    [WidgetModalType.Measurement, ts.getCurrentLanguage()['measurement']],
    [WidgetModalType.RegisterElement, ts.getCurrentLanguage()['register-element']],
    [WidgetModalType.ConvertCoordinate, ts.getCurrentLanguage()['convert-coordinate']],
    [WidgetModalType.MapManagement, ts.getCurrentLanguage()['map-management']],
    [WidgetModalType.PrintMap, ts.getCurrentLanguage()['print-map']],
    [WidgetModalType.Occurrence, ts.getCurrentLanguage()['occurrence']],
    [WidgetModalType.RegisterEvent, ts.getCurrentLanguage()['register-event']],
    [WidgetModalType.Announcements, ts.getCurrentLanguage()['announcements']],
    [WidgetModalType.Path, ts.getCurrentLanguage()['path']],
    [WidgetModalType.Notes, ts.getCurrentLanguage()['notes']],
    [WidgetModalType.Identify, ts.getCurrentLanguage()['identify-results']],
    [WidgetModalType.Help, ts.getCurrentLanguage()['help-menu']],
    [WidgetModalType.AvailableCoverage, ts.getCurrentLanguage()['available-coverage']],
    [WidgetModalType.Tools, ts.getCurrentLanguage()['tools']],

  ]);
}

export function getWidgetModalLogLabelDictionary(ts: TranslationService): Map<WidgetModalType, string> {
  return new Map<WidgetModalType, string>([
    [WidgetModalType.Identify, ts.getCurrentLanguage()['identify']],
  ]);
}

export function getWidgetMapLabelDictionary(ts: TranslationService): Map<WidgetType, string> {
  return new Map<WidgetType, string>([
    [WidgetType.Scales, ts.getCurrentLanguage()['scales']],
    [WidgetType.Coords, ts.getCurrentLanguage()['coordinates']],
    [WidgetType.Overview, ts.getCurrentLanguage()['overview']],
  ]);
}

export function getToolMapLabelDictionary(ts: TranslationService): Map<ToolMapType, string> {
  return new Map<ToolMapType, string>([
    [ToolMapType.CurrentLocation, ts.getCurrentLanguage()['my-location']],
    [ToolMapType.StreetView, ts.getCurrentLanguage()['street-view']],
    [ToolMapType.ZoomByWindow, ts.getCurrentLanguage()['zoom-by-window']],
    [ToolMapType.Fullscreen, ts.getCurrentLanguage()['fullscreen']],
    [ToolMapType.Rotation, ts.getCurrentLanguage()['rotation']],
    [ToolMapType.Identify, ts.getCurrentLanguage()['identify']],
    [ToolMapType.ShareLink, ts.getCurrentLanguage()['share-link']],
    [ToolMapType.AvailableCoverage, ts.getCurrentLanguage()['available-coverage']],
  ]);
}

export function getToolMapActionLabelDictionary(ts: TranslationService): Map<ToolMapActionType, string> {
  return new Map<ToolMapActionType, string>([
    [ToolMapActionType.ZoomIn, ts.getCurrentLanguage()['zoom-in']],
    [ToolMapActionType.ZoomOut, ts.getCurrentLanguage()['zoom-out']],
    [ToolMapActionType.InitialViewpoint, ts.getCurrentLanguage()['initial-viewpoint']],
    [ToolMapActionType.PreviousViewpoint, ts.getCurrentLanguage()['previous-viewpoint']],
    [ToolMapActionType.NextViewpoint, ts.getCurrentLanguage()['next-viewpoint']],
    [ToolMapActionType.Clear, ts.getCurrentLanguage()['clear']],
    [ToolMapActionType.Screenshot, ts.getCurrentLanguage()['screenshot']],
  ]);
}
